<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#a__gjdgxs">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_table_of_contents_1">Acknowledgments</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_table_of_contents_1">Ringing in the Morning</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0005#a__3znysh7" title="Link target outside of Sample">Pizza and Plotting</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0006#a__3dy6vkm" title="Link target outside of Sample">Ninja Hippos</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007#a__2s8eyo1" title="Link target outside of Sample">I Feel Pretty</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0008#a__26in1rg" title="Link target outside of Sample">Party Down</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#a__1ksv4uv" title="Link target outside of Sample">Paybacks</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">About the Author</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">By Kim Katil</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Copyright Page</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?b1762140